import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { CONTACT } from '../lyphline';

// Mobile-only floating call CTA. Hides whenever a form is on screen so it never
// covers input fields, and switches its label to "Call now" past the hero.
const StickyCallButton = () => {
  const location = useLocation();
  const formsRef = useRef([]);
  const [scrolled, setScrolled] = useState(false);
  const [formVisible, setFormVisible] = useState(false);

  const compute = useCallback(() => {
    setScrolled(window.scrollY > 400);
    const vh = window.innerHeight || 0;
    const anyForm = formsRef.current.some((f) => {
      const r = f.getBoundingClientRect();
      return r.top < vh && r.bottom > 0;
    });
    setFormVisible(anyForm);
  }, []);

  // Re-collect forms whenever the route changes (after render settles).
  useEffect(() => {
    setFormVisible(false);
    const t = setTimeout(() => {
      formsRef.current = Array.from(document.querySelectorAll('form'));
      compute();
    }, 400);
    return () => clearTimeout(t);
  }, [location.pathname, compute]);

  useEffect(() => {
    compute();
    window.addEventListener('scroll', compute, { passive: true });
    window.addEventListener('resize', compute);
    return () => {
      window.removeEventListener('scroll', compute);
      window.removeEventListener('resize', compute);
    };
  }, [compute]);

  return (
    <>
      {/* Mobile: left-docked pill (clears the Tawk.to widget on the right) */}
      <a
        href={CONTACT.phoneHref}
        data-testid="sticky-call-btn"
        className={`sm:hidden fixed bottom-4 left-4 z-[60] flex items-center justify-center gap-2 bg-[#CE8946] hover:bg-[#B87333] text-[#003456] font-bold px-5 py-3.5 rounded-full shadow-2xl shadow-black/40 active:scale-[0.98] transition-all duration-300 ${formVisible ? 'opacity-0 translate-y-24 pointer-events-none' : 'opacity-100 translate-y-0'}`}
      >
        <Phone className="h-5 w-5" /> {scrolled ? 'Call now' : 'Call for pricing'}
      </a>

      {/* Desktop: compact bottom-left chip that docks in after the hero */}
      <a
        href={CONTACT.phoneHref}
        data-testid="sticky-call-chip"
        className={`hidden sm:flex fixed bottom-6 left-6 z-[60] items-center gap-2.5 bg-[#CE8946] hover:bg-[#B87333] text-[#003456] font-bold pl-4 pr-5 py-3 rounded-full shadow-2xl shadow-black/30 hover:scale-[1.03] transition-all duration-300 ${scrolled && !formVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-16 pointer-events-none'}`}
      >
        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#003456]"><Phone className="h-4 w-4 text-[#CE8946]" /></span>
        <span className="leading-tight text-left">
          <span className="block text-[11px] font-semibold uppercase tracking-wide opacity-80">Call for pricing</span>
          <span className="block text-sm font-extrabold">{CONTACT.phone}</span>
        </span>
      </a>
    </>
  );
};

export default StickyCallButton;
